import createPlugin from "./create-plugin";

export default createPlugin({
  name: "transform-react-jsx/development",
  development: true,
});
